/**
 * 获取url的参数
 * @param {name} 想获取的url参数名称
 */
export const getUrlCode = name => {
  return (
    decodeURIComponent(
      (new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
        location.href
      ) || [, ""])[1].replace(/\+/g, "%20")
    ) || null
  );
};

/**
 * 获取截取去掉指定参数的地址
 */
export const getHref = (...arg) => {
  //跳转地址
  let param = Array.from(arg);
  let location = window.location;
  let search = location.search;
  console.log(search);
  if (search) {
    search = search.substr(1);
  }
  let href = location.origin;
  console.log(href);
  let pathName = location.pathname;
  console.log(pathName);
  if (pathName) {
    href += pathName;
  }
  let searchArr = search.split("&").filter(item => {
    let flag = true;
    param.forEach(v => {
      if (item.indexOf(v + "=") !== -1) {
        flag = false;
      }
    });
    return flag;
  });
  if (searchArr.length > 0) {
    href += "?" + searchArr.join("&");
  }
  let hash = location.hash;
  if (hash) {
    href += hash;
  }
  return href
};

/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string | null}
 */
 export function parseTime(time, cFormat) {
  if (arguments.length === 0 || !time) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if ((typeof time === 'string')) {
      if ((/^[0-9]+$/.test(time))) {
        // support "1548221490638"
        time = parseInt(time)
      } else {
        // support safari
        // https://stackoverflow.com/questions/4310953/invalid-date-in-safari
        time = time.replace(new RegExp(/-/gm), '/')
      }
    }

    if ((typeof time === 'number') && (time.toString().length === 10)) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
    const value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value ] }
    return value.toString().padStart(2, '0')
  })
  return time_str
}

export function setNewDate(data){
  let Time =  parseTime(data).replace(/-/g, '/');
  let date = new Date(Time)
  return date
}



// WEBPACK FOOTER //
// ./src/util/index.js